import request from '@/utils/request'

// 待租数据看板接口
// 不可发车辆概览、可发车辆概览、可发已备车
export function getVehicleHoldInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleHoldInfo',
    method: 'POST',
    data,
  })
}

// 不可发车数量-折线图
export function getToDealNum(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNum',
    method: 'POST',
    data,
  })
}

// 不可发车率-折线图
export function getToDealRate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealRate',
    method: 'POST',
    data,
  })
}

// 不可发原因概览（证照、不可租标签、违章、事故、保险、维保）
export function getToDealReason(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealReason',
    method: 'POST',
    data,
  })
}

// 证照原因不可发-折线图
export function getToDealNumWithLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNumWithLicense',
    method: 'POST',
    data,
  })
}

// 不可发标签原因不可发-折线图
export function getToDealNumWithTag(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNumWithTag',
    method: 'POST',
    data,
  })
}

// 违章原因不可发-折线图
export function getToDealNumWithViolation(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNumWithViolation',
    method: 'POST',
    data,
  })
}

// 事故原因不可发-折线图
export function getToDealNumWithAccident(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNumWithAccident',
    method: 'POST',
    data,
  })
}

// 保险原因不可发-折线图
export function getToDealNumWithInsurance(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNumWithInsurance',
    method: 'POST',
    data,
  })
}

// 维保原因不可发-折线图
export function getToDealNumWithMaintenance(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toDealNumWithMaintenance',
    method: 'POST',
    data,
  })
}

// 订单锁定车辆概览（个人订单、企业子订单）
export function getOrderLockCarNum(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/orderLockCarNum',
    method: 'POST',
    data,
  })
}

// 可发车辆数量-折线图
export function getToLeaseNum(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/toLeaseNum',
    method: 'POST',
    data,
  })
}

// 可发车平均在库时长-折线图
export function getAvgInStockDay(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/avgInStockDay',
    method: 'POST',
    data,
  })
}

// 保险利用率-折线图
export function getInsuranceUsedRate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/insuranceUsedRate',
    method: 'POST',
    data,
  })
}

// 查询全部的车型 - 基于车系去重
export function getSeriesList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/listAllWithSeries',
    method: 'POST',
    data,
  })
}

// 可发车辆在库时长top20车辆
export function getInStockDayTop(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/inStockDayTop',
    method: 'POST',
    data,
  })
}
